import * as React from 'react';
import styled from 'styled-components';
import { Form, FormGroup, Nav, NavItem, Row, Table } from 'react-bootstrap';

export const NavWrapper = styled(Nav)`
    margin-bottom: -1px;

    & > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: white;
        color: black;
        // width: 160px;
        text-align: center;
        border-width: 1px 1px 0px 1px;
        border-style: solid;
        border-color: #ddd;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: #337ab7;
        color: white;
    }

    & > li.active > a {
        font-size: 16px;
        background-color: #337ab7;
        color: white;
        // padding: 9px 15px;
    }

    @media (max-width: 1920px) {
        height: 55px;
        
        & > li {
            height: 100%;
        }

        & > li > a {
            font-size: 12px;
            line-height: 15px;
            inline-size: 100px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        & > li.active > a {
            font-size: 13px;
            line-height: 15px;
        }
    }
`;

export const NavItemStaticWrapper = styled.label`
    background-color: #337ab7 !important;
    color: white !important;
    float: left !important;
    margin-top: 5px;
    margin-right: 5px;
    border-radius: 5px;
    text-align: center;
    padding: 5px;    
`;

interface INavItemProps {
    tabWidth?: string
}

export const HeaderWrapper = styled.div<{ expand: boolean }>`
    margin-bottom: 10px;
    padding-top: 3px;
    padding-bottom: 3px;
    
    .donor-progress-bar {
        min-height: 40px;
        padding: 5px;
        display: flex;
        align-items: center;
    }

    .header-left {
        display: flex;
        align-items: center;
        padding-right: 20px;
        flex-grow: 1;
        flex-basis: 100px;
        cursor: default;
    }

    .header-buttons {
        flex-grow: 5;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .header-buttons > .item-button {
        flex-grow: 2;
        flex-basis: 250px;
    }

    .header-buttons > .item-divider {
        padding-left: 10px;
        padding-right: 10px;
        flex-grow: 1;
        color: #ddd;
        text-align: center;
        // border: 1px solid green;
    }

    .donor-progress-messages {
        padding: 5px 10px 10px 10px;
    }
`;

export const ProfileWrapper = styled.div`
    .nav > li.admin.active > a {
        background-color: orange;
        color: white;
        font-weight: normal;
    }

    .nav > li.admin > a {
        color: orange;
        font-weight: bold;
    }

    .donor-profile-section {
        border-width: 1px 1px 1px 1px;
        border-style: solid;
        // border-color: #337ab7;
        border-color: #ddd;
        // border-radius: 4px;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .donor-profile-content {
        .form-group {
            // border: 1px solid red;
        }

        .yes-no-unknown {
            height: 34px;
            padding-top: 7px;
        }
    }

    .donor-profile-adp {
        // border-bottom: 1px solid #ccc;
        border-radius: 4px;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .form-horizontal .form-group {
        margin-bottom: 5px;
    }

    .form-horizontal .control-label {
        text-align: left;
    }

    .declines span.label {
        font-size: 100%;
        display: block;
        width: 50px;
        padding: .4em .6em .4em;
    }

    .declines .decline-label {
        padding-top: 0.4rem;
    }

    .accepts > table > thead > tr > th,
    .accepts > table > tbody > tr > td {
        text-align: center;
    }

    .accepts > table > tbody > tr > td > .label {
        font-size: 100%;
    }

    .panel-heading {
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .donor-records > .row:nth-child(odd) {
        background-color: #eee;
        padding-top: 5px;
        padding-bottom: 5px;
    }

    .important-highlight {
        background: #ffd248;
        padding: 5px;
        border-radius: 4px;
    }

    .container-fluid, .panel, .table-condensed { 
        margin-top: 5px;
    }
`;

export const TabWrapper = styled.div`
    width: 100%;
    border-top: 1px solid #80A3BF;
    border-left: 1px solid #80A3BF;
    border-right: 1px solid #80A3BF;
    border-bottom: 1px solid #80A3BF;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    min-height: 55vh;
    padding: 10px;
    background-color: #FFF;
    margin-bottom: 10px;
`;

export const NavItemWrapper = styled(NavItem) <INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.tabWidth ? p.tabWidth + 'px !important' : '150px'};
    // }

    // & > a {
    //     min-width: 140px;
    // }

    margin-bottom: 0px !important;

    .active > a {
        border-color: #337ab7 !important;
    }
`;

export const GridWrapper = styled.div`
    width: 100%;
    height: 56vh;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #ddd;
        color: #123;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        // font-weight: 700;
        font-size: 13px;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    div.ag-root .ag-cell-focus {
        user-select: text !important;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #ccc;
        font-size: 13px;
    }

    .list-cell > .ag-cell-wrapper {
        display: flex;
        justify-content: center;
    }

    .list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #B7B7B7;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        border-color: #eee;
        border-width: 0px 0px 0px 1px;
        border-style: solid;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .totals {
        font-weight: 600;
        background-color: #ddd;
    }

    .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
        background-color: lightgoldenrodyellow;
    }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    .customHeaderLabel {
        margin-left: 5px;
        float: left;
        text-align: center;
    }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }
`;

export const RowWrapper = styled(Row)`
    margin-bottom: 10px;
    display: flex;
    align-items: center;
`;


export const ViewWrapper = styled(Form)`
    padding: 20px;

    .recipient-profile-section {
        border-width: 1px 1px 1px 1px;
        border-style: solid;
        // border-color: #337ab7;
        border-color: #ddd;
        // border-radius: 4px;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .recipient-profile-content {
        .form-group {
            // border: 1px solid red;
        }

        .yes-no-unknown {
            height: 34px;
            padding-top: 7px;
        }
    }

    .paired-donors > .table {
        font-size: 12px;
    }

    .paired-donors > .table > thead > tr > th,
    .paired-donors > .table > tbody > tr > td {
        text-align: center;
    }
`;

export const FormGroupWrapper = styled(FormGroup)`
    margin-bottom: 5px;
`;

export const CreatinineTableWrapper = styled(Table)`
    // width: initial;

    & > thead > tr > th {
        // text-align: center;
        vertical-align: middle;
    }

    & > tbody > tr > td {
        vertical-align: middle;
        // text-align: center;
    }

    .form-group {
        margin: 0;
    }

    label {
        margin: 0;
    }
`;

export const styles: { [key: string]: React.CSSProperties } = {
    progressMessage: {
        marginBottom: 5
    },
    progressMessageLast: {
        marginBottom: 0
    },
    progressMessageIntro: {
        marginBottom: 5
    },
    progressMessageList: {
        paddingInlineStart: 20
    },
    progressMessageListItem: {
        listStyleType: 'disc'
    }
};